<template>
  <div id="Menu">
    <div class="navbar-fixed hide-on-large-only">
      <nav class="nav-wrapper" v-if="this.$route.params.cateringId != undefined || this.$route.params.dishId != undefined">
        <div class="container">
          <router-link
            v-bind:to="{name:'SearchCatering'}"
            class="brand-logo hide-on-med-and-up"
          >S&amp;B</router-link>
          <router-link
            v-bind:to="{name:'SearchCatering'}"
            class="brand-logo hide-on-small-only"
          >Servicio &amp; Bienestar</router-link>
          
          <ul id="nav-mobile" class="left" v-if="this.$route.params.dishId != undefined">
            <li>
              <router-link
                v-bind:to="{name:'InfoCatering',params:{'cateringId':10}}"
              ><i class="material-icons">arrow_back_ios</i></router-link>
            </li>
          </ul>
        <!--
          <a href="#" class="sidenav-trigger" data-target="mobile-links">
            
          </a>
          -->
        </div>
      </nav>
    </div>

    <ul id="mobile-links" class="sidenav">
      <li>
        <!--
        <div class="user-view center">
          <div class="background">
            <img "./assets/logo.png" alt="bg Perfil">
          </div>
          <div class="img-movil avatar">
            <img "./assets/logo.png"
              alt="Servicio &amp; Bienestar"
              class="circle responsive-img "
              style="width:35%;height:35%"
            >
          </div>
          <span class="white-text name">July Andrea Torres Orejuela</span>
          <a href="#contacts" class="sidenav-close">
            <span class="white-text email">
              <i class="tiny material-icons pink-text">mail</i> julytorres8812@hotmail.com <i class="tiny material-icons pink-text">mail</i>
            </span>
          </a>
          <a href="tel:+57 315 8314523" class="sidenav-close">
            <span class="white-text email">
              <i class="tiny material-icons pink-text">phone_android</i> +57 315 8314523 <i class="tiny material-icons pink-text">phone_android</i>
            </span>
          </a>
        </div>
        -->
      </li>
      <!--
      <li>
        <a href="#about" class="sidenav-close">
          <i class="small material-icons pink-text">face</i> Perfil Profesional
        </a>
      </li>
      <li>
        <a href="#studies" class="sidenav-close">
          <i class="small material-icons pink-text">school</i> Estudios y Conocimientos
        </a>
      </li>
      <li>
        <a href="#experience" class="sidenav-close">
          <i class="small material-icons pink-text">business_center</i> Experiencia Laboral
        </a>
      </li>
      <li>
        <a href="#references" class="sidenav-close">
          <i class="small material-icons pink-text">account_circle</i> Referencias
        </a>
      </li>
      <li>
        <a href="#contacts" class="sidenav-close">
          <i class="small material-icons pink-text">message</i> Contactame
        </a>
      </li>
      <li>
        <div class="divider"></div>
      </li>
      <li>
        <a class="subheader">Sigueme:</a>
      </li>
      
      <li>
        <a class="waves-effect" href="#!">
          <i class="fa fa-2x fa-envelope pink-text"></i>
          <i class="fa fa-2x fa-facebook-f pink-text"></i>
          <i class="fa fa-2x fa-linkedin pink-text"></i>
          <i class="fa fa-2x fa-instagram pink-text"></i>
        </a>
      </li>
      -->
    </ul>
  </div>
</template>
<script>
export default {
  name: "Menu"
  //props: ["ObjRutas"]
};
</script>
<style>
.img-movil {
  display: flex;
  justify-content: center;
  align-items: center;
}
.nav-wrapper{
  background-color: #7f0000 !important;
  color:#ffffff;
}
</style>




// WEBPACK FOOTER //
// src/components/elements/Menu.vue